import React from 'react'

const ColoredText = ({color, underlined, children, sx}) => {
    return (
        <span style={{...sx, color: color, mixBlendMode: 'none'}}>{children}</span>
    )
}

export default ColoredText